import { permissionhost as host } from '@views/permission-group/permission-config-host'
let base = window._env_.VUE_APP_ADMIN_HOST

export const getRolesIndex = params => {
  return axios.post(`${host(params)}/permissions/role/query`, params)
}
export const getRoleDetail = params => {
  return axios.get(`${host(params)}/permissions/role/get_${params.id}`)
}
export const addRole = params => {
  return axios.post(`${host(params)}/permissions/role/add`, params)
}
export const editRole = params => {
  return axios.post(`${host(params)}/permissions/role/edit_${params.id}`, params)
}
export const copyRole = params => {
  return axios.post(`${host(params)}/permissions/role/copy_${params.id}`)
}
export const deleteRole = params => {
  return axios.post(`${host(params)}/permissions/role/remove_${params.id}`)
}

// UI permissions
export const getUiRolesIndex = params => {
  return axios.post(`${base}/uipermission/role/query`, params)
}
export const getUiRolePermissionsIndex = params => {
  return axios.post(`${base}/uipermission/role/query_permission`, params)
}
export const getUiRoleDetail = (params) => {
  return axios.get(`${base}/uipermission/role/get_${params.id}`)
}
export const createUiRole = params => {
  return axios.post(`${base}/uipermission/role/create`, params)
}
export const updateUiRole = params => {
  return axios.post(`${base}/uipermission/role/update_${params.id}`, params)
}
export const copyUiRole = params => {
  return axios.post(`${base}/uipermission/role/copy_${params.id}`, params)
}
export const deleteUiRole = params => {
  return axios.post(`${base}/uipermission/role/delete_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/platform-role/platform-role.api.js